export default __webpack_public_path__ + "static/russian-4-a3ba60711b1019f280dfa3e74e231fb0.jpg";